import {IItem} from '../interfaces';
import {ItemSimplePayload} from './item-simple-payload.classes';

export class Item<T> extends ItemSimplePayload implements IItem<T> {
  public readonly payload: T;

  constructor(data: IItem<T>) {
    super(data);
    this.payload = data.payload;
  }
}
